import { GlobalStyles } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export const GoogleMapsGlobalStyles = () => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';

  return (
    <GlobalStyles
      styles={{
        '.pac-container': {
          backgroundColor: isDarkMode ? `${theme.palette.grey[800]} !important` : '#ffffff !important',
          color: isDarkMode ? theme.palette.text.primary : '#000000',

          borderRadius: '8px',
          marginTop: '5px',
          fontFamily: theme.typography.fontFamily,
          zIndex: 9999,

          border: isDarkMode ? `1px solid ${theme.palette.grey[700]}` : '1px solid transparent',
          boxShadow: isDarkMode
            ? '0px 4px 20px rgba(0, 0, 0, 0.5) !important'
            : '0px 4px 20px rgba(0, 0, 0, 0.15) !important',
        },

        'iframe[name="helpcrunch-iframe"]': {
          left: '5px !important',
          right: 'auto !important',
          bottom: '5px !important',
          opacity: '0.5',

          position: 'fixed !important',
        },

        '.pac-item': {
          padding: '10px 15px',
          cursor: 'pointer',
          borderTop: isDarkMode ? `1px solid ${theme.palette.grey[700]} !important` : '1px solid #f0f0f0 !important',

          color: isDarkMode ? theme.palette.text.secondary : '#666666',

          '&:hover': {
            backgroundColor: isDarkMode ? `${theme.palette.grey[700]} !important` : '#f5f5f5 !important',

            borderTopColor: 'transparent !important',
          },

          '&:first-of-type': {
            borderTop: 'none !important',
            borderTopLeftRadius: '8px',
            borderTopRightRadius: '8px',
          },
          '&:last-of-type': {
            borderBottomLeftRadius: '8px',
            borderBottomRightRadius: '8px',
          },
        },

        '.pac-item-query': {
          color: isDarkMode ? '#ffffff !important' : '#000000 !important',
          fontWeight: 'bold',
          fontSize: '14px',
        },

        '.pac-item span': {
          fontSize: '12px',
          color: isDarkMode ? theme.palette.grey[400] : '#757575',
        },

        '.pac-icon': {
          filter: isDarkMode ? 'invert(1) grayscale(100%) brightness(200%)' : 'grayscale(100%) opacity(0.6)',

          marginTop: '3px',
        },

        '.pac-container:after': {
          display: 'none !important',
        },
      }}
    />
  );
};
